import React from "react";
import classnames from "classnames";
import "./index.scss";

export interface StatusLabelProps {
  textStatus: string;
  text: string;

  circleStatus?: string;
  additionalText?: string;

  className?: string;
}

const TableColumnLabel: React.FC<StatusLabelProps> = (props) => {
  const { circleStatus, textStatus, text, additionalText, className } = props;

  return (
    <div className={classnames("status-wrapper", className)}>
      {circleStatus ? <div className={classnames("status-circle-label", circleStatus)} /> : null}
      <div className={classnames("status-text-label", textStatus)}>{text}</div>
      {additionalText ? <div className="status-additional-text-label">{additionalText}</div> : null}
    </div>
  );
};

export default TableColumnLabel;
